module.exports = __webpack_public_path__ + "static/media/whychoose_3.2eb515bd.jpg";